import { useCallback, useMemo } from "react";
import useToasts from "../../../root/core-ui/toast/useToasts.ts";
import LaunchErrorToast from "../common/LaunchErrorToast.tsx";
import { useLayoutData } from "../layout/myCoursesLayoutLoader.ts";
import { useContentAccessFetcher } from "../actions/contentAccessAction.ts";

export default function useLaunchPiCourseware(
  onDone?: (lmsLink?: string) => void
) {
  const { showToast } = useToasts();
  const { config } = useLayoutData();
  const fetcher = useContentAccessFetcher();

  const launchPiCourseware = useCallback(
    (path: string) => {
      return fetcher
        .submit(
          {
            path,
          },
          {
            action: `/my-courses/content-access`,
            method: "POST",
          }
        )
        .then((result) => {
          if (result.data?.ok) {
            const redirectUrl = result.data?.data?.redirectUrl;
            if (redirectUrl) {
              window.open(redirectUrl, "_blank", "noopener");
            } else {
              showToast(<LaunchErrorToast />);
            }
            onDone?.();
          } else {
            const requiresLmsLaunch = result.data?.status === 422;
            const lmsLink = config.sal.contentAccessUrl;
            if (requiresLmsLaunch && lmsLink) {
              onDone?.(lmsLink);
            } else {
              showToast(<LaunchErrorToast />);
              onDone?.();
            }
          }
        })
        .catch(() => {
          showToast(<LaunchErrorToast />);
          onDone?.();
        });
    },
    [fetcher, config.sal.contentAccessUrl, onDone, showToast]
  );

  const isLaunchPiCoursewareProcessing = fetcher.state !== "idle";

  return useMemo(
    () => ({
      isLaunchPiCoursewareProcessing,
      launchPiCourseware,
    }),
    [isLaunchPiCoursewareProcessing, launchPiCourseware]
  );
}
